module.exports = __webpack_public_path__ + "img/select_menu_bottom_btn.d3888e96.png";